import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { ClientListRequestBody, ClientListResponse } from "./types";

export class ClientListAPI extends BaseAPI<
    ClientListRequestBody,
    ClientListResponse
> {
    protected route = ApiRoutes.client.list;
    protected method = RequestMethod.GET;
    protected params = ["search", "page", "page_size"];
}